import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  Textarea,
} from "@chakra-ui/react";

const DisputeResponseDialog = ({ isOpen, onClose, dispute, onSubmit, isSubmitting }) => {
  const [notes, setNotes] = useState("");
  const [metadataText, setMetadataText] = useState("");
  const [submitNow, setSubmitNow] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen) {
      setNotes("");
      setMetadataText("");
      setSubmitNow(true);
      setError("");
    }
  }, [isOpen, dispute?.id]);

  const handleSubmit = async () => {
    if (!notes.trim()) {
      setError("Notes are required.");
      return;
    }
    let metadata;
    if (metadataText.trim()) {
      try {
        metadata = JSON.parse(metadataText);
      } catch (err) {
        setError("Metadata must be valid JSON.");
        return;
      }
    }
    setError("");
    const result = await onSubmit({
      paymentId: dispute?.id,
      notes: notes.trim(),
      metadata,
      submit: submitNow,
    });
    if (result?.ok) {
      onClose();
    } else if (result?.error) {
      setError(result.error);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Submit Dispute Response</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Stack spacing={4}>
            <Text color="gray.600">
              Provide evidence or notes for payment {dispute?.id || "-"}.
            </Text>
            <FormControl isRequired>
              <FormLabel>Notes</FormLabel>
              <Textarea
                value={notes}
                onChange={(event) => setNotes(event.target.value)}
                placeholder="Service delivered on 2024-12-01."
                rows={4}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Metadata (JSON)</FormLabel>
              <Textarea
                value={metadataText}
                onChange={(event) => setMetadataText(event.target.value)}
                placeholder='{"caseId":"case_123"}'
                rows={3}
              />
            </FormControl>
            <Checkbox isChecked={submitNow} onChange={(event) => setSubmitNow(event.target.checked)}>
              Submit to Stripe now
            </Checkbox>
            {error ? (
              <Text fontSize="sm" color="red.600">
                {error}
              </Text>
            ) : null}
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="blue" onClick={handleSubmit} isLoading={isSubmitting}>
            Submit Response
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DisputeResponseDialog;
